import Isotope from 'isotope-layout'
import packery from 'isotope-packery'
import Channels from '../../base/channels'
import Env from '../../base/env';

export default class Grid
{
    constructor(view)
    {
        this.view  = view
        this.reference = this.view.querySelector('.jsIsotope--view')
        this.$sizers = this.view.querySelectorAll('.jsSizer')
        this.gutter = (Env.mobileCSS)?30:45
        this.nbColumns = false
        this.klassItems = '.jsIsotope--item'
        this.klassSizer = '.jsIsotope--sizer'
        this.funcSizer = this.resize.bind(this)
        this.funcFiltering = this.refresh.bind(this)
        this.dimensionsVertical = { width : 550 , height : 685 }
        this.dimensionsHorizontal = { width : 550 , height : 320 }
    }

    destroy()
    {
        Channels.removeListener('window::smartresize',this.funcSizer)
        Channels.removeListener('filtering::success',this.funcFiltering)
    }

    events()
    {
        Channels.on('window::smartresize',this.funcSizer)
        Channels.on('filtering::success',this.funcFiltering)
    }

    lazyUpdate($items)
    {
        this.sizeGrid($items,true)
        this.isotope.insert( $items )
        for(let i = 0; i < $items.length; i++) {
            $items[i].classList.add('jsLazy--isDone')
        }
    }

    refresh()
    {
        this.isotope.destroy()
        this.reference = this.view.querySelector('.jsIsotope--view')
        this.sizeGrid()
        this.isotope = new Isotope( this.reference , {
            // options
            itemSelector: this.klassItems,
            percentPosition: true,
            layoutMode: 'packery',
            packery : {
                gutter: this.gutter
            }
        });
    }

    setup()
    {
        this.sizeGrid()

        this.isotope = new Isotope( this.reference , {
            // options
            itemSelector: this.klassItems,
            percentPosition: true,
            layoutMode: 'packery',
            packery : {
                gutter: this.gutter
            }
        });
        this.events()
    }

    resize()
    {
        this.sizeGrid()

        if(typeof this.isotope !== 'undefined') {
            this.isotope.layout()
        }
    }

    sizeGrid($itemsParams = [] , refreshMode = false)
    {
        const getViewport = Env.framework.toolbox.getViewport()
        this.nbColumns = (this.view.querySelector('.jsSearchIndex') != null)?3.1:2
        if(getViewport.width < 1500 && this.view.querySelector('.jsSearchIndex') != null) {
            this.nbColumns = 3.18
        }
        const $sizerIsotope = this.view.querySelector(this.klassSizer)
        const ratioVertical = this.dimensionsVertical.width / this.dimensionsVertical.height
        const ratioHorizontal = this.dimensionsHorizontal.width / this.dimensionsHorizontal.height
        let $items;
        if($itemsParams.length) {
            $items = $itemsParams
        } else {
            $items = this.view.querySelectorAll(this.klassItems)
        }

        if(refreshMode == false) {
            this.reference.removeAttribute('style')
            $sizerIsotope.removeAttribute('style')
        }

        const getWidth = this.reference.getBoundingClientRect().width
        let sizeReference
        if(Env.mobileCSS) {
            sizeReference = {width : getWidth, height : 'auto' }
        } else {
            sizeReference = {width : (getWidth - this.gutter) / this.nbColumns, height : 'auto' }
        }


        var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
        if(browserZoomLevel < 200) {
            sizeReference.width = sizeReference.width / 1.02
        }

        // Horizontal reference
        let newSizeHorizontal = { width : sizeReference.width , height : 0 }
        newSizeHorizontal.height = Math.round(newSizeHorizontal.width / ratioHorizontal)
        // Vertical reference
        let newSizeVertical = { width : sizeReference.width , height : 0 }
        newSizeVertical.height = newSizeHorizontal.height * 2 + this.gutter // == deux hauteurs de bloc horizontal + goutière


        for(let j = 0; j < $items.length; j++) {
            const $item = $items[j]
            if($item.classList.contains('layout--vertical'))
            {
                $item.style.width = `${newSizeVertical.width}px`
                $item.style.height = `${newSizeVertical.height}px`
            }
            if($item.classList.contains('layout--horizontal'))
            {
                $item.style.width = `${newSizeHorizontal.width}px`
                $item.style.height = `${newSizeHorizontal.height}px`
            }
        }
        if(refreshMode == false) {
            $sizerIsotope.style.width = `${sizeReference.width}px`
            this.reference.style.width = `${getWidth}px`
        }
    }

}